import { Component, Input, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NavigationLink } from './navigation-link';
import { MatTabLink } from '@angular/material/tabs';
import { SWIPER_OPTIONS } from '@shared/component/navigation/swiper-options';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import { BaseComponent } from '@shared/component/base/base.component';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  standalone: false
})
export class NavigationComponent extends BaseComponent {
  @ViewChildren(MatTabLink) tabLinks: QueryList<MatTabLink>;
  @ViewChild('swiper') swiper: SwiperComponent;
  @Input() links: NavigationLink[];
  // tabs classes: primary/secondary/light
  @Input() inputClass: string = 'primary';
  carouselConfig: SwiperOptions = SWIPER_OPTIONS;

  slideToActiveTab(index: number): void {
    this.swiper.swiperRef.slideTo(index);
  }
}
